import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../redux-stores/store';
import { useEffect, useState } from 'react';
import { setIntendedPath } from '../../redux-stores/slices/layoutSlice';
import { login } from '../../redux-stores/slices/authSlice';
import { fetchInfluencer } from '../../redux-stores/slices/influencerSlice';

const ifAuthenticated = (WrappedComponent: React.FC): React.FC => {
    return (props: any) => {
        const { isAuthenticated, authInitialized } = useSelector((state: RootState) => state.auth);
        const location = useLocation();
        const dispatch: AppDispatch = useDispatch();
        const navigate = useNavigate();
        const urlParams = new URLSearchParams(location.search);
        const token = urlParams.get('token');

        const [authAttempted, setAuthAttempted] = useState(false);
        const [authLoading, setAuthLoading] = useState(false);
        const [tokenRemoved, setTokenRemoved] = useState(false);

        useEffect(() => {
            if (!isAuthenticated && token && !authAttempted) {
                // decode token first
                setAuthAttempted(true);
                setAuthLoading(true);

                const authenticate = async () => {
                    const decodedToken = atob(token);
                    await dispatch(fetchInfluencer(decodedToken));
                    const userData = await dispatch(login(decodedToken)).unwrap();
                    if(!userData?.userData?.user){
                        navigate('/register');
                    }
                };

                try {
                    authenticate().then(() => setAuthLoading(false)).catch((error) => {
                        console.log('Authentication failed:', error);
                        navigate('/register');
                        setAuthLoading(false);
                    });
                } catch (error) {
                    console.log('Authentication failed:', error);
                    navigate('/register');
                    setAuthLoading(false);
                }

            }
        }, [token, isAuthenticated, authAttempted, dispatch]);

        useEffect(() => {
            if (isAuthenticated && token && !tokenRemoved) {
                urlParams.delete('token');
                const newQuery = urlParams.toString();
                const newUrl = location.pathname + (newQuery ? `?${newQuery}` : '');
                window.history.replaceState({}, '', newUrl);
                setTokenRemoved(true);
            }
        }, [isAuthenticated, token, tokenRemoved, location.pathname]);

        useEffect(() => {
            if (!isAuthenticated && !token) {
                dispatch(setIntendedPath(location.pathname + location.search));
            }
        }, [isAuthenticated, token, location.pathname, location.search]);

        if (authLoading) {
            return null;
        }

        if (!isAuthenticated && !token) {
            return <Navigate to="/register" replace />;
        }

        return <WrappedComponent {...props} />;
    };
};

export default ifAuthenticated;